import { Experiment } from '@cian/experiments/ab';
import { MobileSlidingContainer } from '@cian/frontend-mobile-sliding-container';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Container } from '../../components/Container';
import { SearchFiltersBlock } from '../../components/SearchFiltersBlock';
import { Section } from '../../components/Section';
import { AUD_MOBILE_REDESIGN_MAINPAGE } from '../../constants/experiments';
import { selectExperiments } from '../../selectors/experiments';
import { isExperimentActive } from '../../utils/experiments';
import { AddOfferButtonContainer } from '../AddOfferButtonContainer';
import { AdfoxBrandBannerContainer } from '../AdfoxBrandBannerContainer';
import { BottomNavigationContainer } from '../BottomNavigationContainer';
import { GeoLocationModalContainer } from '../GeoLocationModalContainer';
import { PikPromoBannerContainer } from '../PikPromoBannerContainer';
import { QuickFiltersContainer } from '../QuickFiltersContainer';
import { QuickLinksContainer } from '../QuickLinksContainer';
import { RecommendationsContainer } from '../RecommendationsContainer';
import { RegionSelectCallContainer } from '../RegionSelectCallContainer';
import { SearchBlockContainer } from '../SearchBlockContainer';
import { SeoCrossLinksContainer } from '../SeoCrossLinksContainer';
import { SeoDescriptionContainer } from '../SeoDescriptionContainer';
import { SeoRegionsContainer } from '../SeoRegionsContainer';
import { ServicesContainer } from '../ServicesContainer';

export const Page: React.FC = () => {
  const experiments = useSelector(selectExperiments);
  const isRedesignExperiment = isExperimentActive(experiments, AUD_MOBILE_REDESIGN_MAINPAGE, ['B', 'C']);

  return (
    <>
      {isRedesignExperiment && (
        <>
          <Section>
            <SearchFiltersBlock searchBlock={<SearchBlockContainer />} quickFilters={<QuickFiltersContainer />} />
          </Section>

          <Section indent="S" sideIndent="S">
            <ServicesContainer />
          </Section>
        </>
      )}
      <Container>
        <Experiment name={AUD_MOBILE_REDESIGN_MAINPAGE} group="A" default>
          <SearchBlockContainer />

          <Section>
            <QuickFiltersContainer />
          </Section>

          <AddOfferButtonContainer />

          <Section indent="M">
            <ServicesContainer />
          </Section>
        </Experiment>

        <Section indent="S">
          <AdfoxBrandBannerContainer />
        </Section>

        <Section indent="M">
          <RecommendationsContainer />
        </Section>

        <PikPromoBannerContainer />

        <QuickLinksContainer />

        <SeoRegionsContainer />

        <SeoDescriptionContainer />

        <SeoCrossLinksContainer />

        <GeoLocationModalContainer />
      </Container>
      <MobileSlidingContainer>
        <RegionSelectCallContainer />
        <BottomNavigationContainer />
      </MobileSlidingContainer>
    </>
  );
};
